import { render, staticRenderFns } from "./addMessageConfig.vue?vue&type=template&id=93591656&scoped=true"
import script from "./addMessageConfig.vue?vue&type=script&lang=js"
export * from "./addMessageConfig.vue?vue&type=script&lang=js"
import style0 from "./addMessageConfig.vue?vue&type=style&index=0&id=93591656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93591656",
  null
  
)

export default component.exports